import { Box, Flex, VStack, HStack, Text, Heading, Button, Progress, Divider } from "@chakra-ui/react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { HERO_GRADIENT } from "../../../shared/theme/foundations/gradients";
import { formatBRL } from "../../../shared/lib/currency";
import { describePaymentMonth } from "../../plantoes/utils/paymentMonth";

export default function HeroSummaryCard({ overview }) {
  const navigate = useNavigate();
  const { registrarPlantaoDisclosure } = useOutletContext() ?? {};

  const pctRecebido = Math.round((overview?.percentual_recebido ?? 0) * 100);
  // Só um mês do calendário traz ano/mes preenchidos; "todos os períodos" e o período
  // personalizado vêm zerados do backend.
  const periodo = overview?.periodo;
  const legendaMesPagamento = periodo?.ano && periodo?.mes ? describePaymentMonth(periodo) : null;

  return (
    <Box bgGradient={HERO_GRADIENT} borderRadius="xl" color="white" p={{ base: 5, md: 7 }} boxShadow="md">
      <Flex direction={{ base: "column", lg: "row" }} gap={6} align={{ lg: "center" }}>
        <VStack align="flex-start" spacing={3} flex={1}>
          <Text fontSize="sm" opacity={0.85}>
            Total a receber · {overview?.periodo?.rotulo}
          </Text>
          {legendaMesPagamento ? (
            <Text fontSize="xs" opacity={0.85} mt={-2}>
              {legendaMesPagamento}
            </Text>
          ) : null}
          <Heading size="2xl" fontSize={{ base: "3xl", md: "5xl" }} letterSpacing="tight">
            {formatBRL(overview?.total_a_receber_mes ?? 0)}
          </Heading>
          <Text fontSize="sm" opacity={0.85}>
            Faturamento previsto de {formatBRL(overview?.faturamento_previsto ?? 0)} · {formatBRL((overview?.faturamento_previsto ?? 0) - (overview?.total_a_receber_mes ?? 0))} já recebido
          </Text>
          <Box w="100%" maxW="420px">
            <HStack justify="space-between" mb={1}>
              <Text fontSize="xs" opacity={0.85}>
                {pctRecebido}% já recebido
              </Text>
            </HStack>
            <Progress value={pctRecebido} size="sm" borderRadius="full" bg="whiteAlpha.300" sx={{ "& > div": { bg: "white" } }} />
          </Box>
          <HStack spacing={3} pt={1} flexWrap="wrap">
            <Button variant="onBrand" size="sm" onClick={registrarPlantaoDisclosure?.onOpen}>
              Registrar plantão
            </Button>
            <Button variant="ghost" size="sm" color="white" _hover={{ bg: "whiteAlpha.200" }} onClick={() => navigate("/recebiveis")}>
              Ver recebíveis
            </Button>
          </HStack>
        </VStack>

        <Box bg="whiteAlpha.200" borderRadius="lg" p={4} minW={{ lg: "260px" }}>
          <Text fontSize="sm" fontWeight="semibold" mb={3}>
            Atenção imediata
          </Text>
          <VStack align="stretch" spacing={3}>
            <HStack justify="space-between">
              <Text fontSize="xs" opacity={0.85}>
                Em atraso ({overview?.plantoes_em_atraso ?? 0} plantões)
              </Text>
              <Text fontSize="sm" fontWeight="bold">
                {formatBRL(overview?.valor_em_atraso ?? 0)}
              </Text>
            </HStack>
            <Divider borderColor="whiteAlpha.400" />
            <HStack justify="space-between">
              <Text fontSize="xs" opacity={0.85}>
                Vencendo esta semana
              </Text>
              <Text fontSize="sm" fontWeight="bold">
                {formatBRL(overview?.valor_vencendo_semana ?? 0)}
              </Text>
            </HStack>
          </VStack>
        </Box>
      </Flex>
    </Box>
  );
}
